export default __webpack_public_path__ + "31ca6248f4e74d04b157096619854bd1.svg";